<div class="container" [ngSwitch]="data?.extra2">
    <div class="wrap" [ngClass]="data?.extra2">
        <ng-container *ngSwitchCase="'redirect_product'" [ngTemplateOutlet]="redirect"></ng-container>
        <ng-container *ngSwitchCase="'promo_' + currentProduct?.id" [ngTemplateOutlet]="promo"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="other"></ng-container>
    </div>
    <ng-container *ngSwitchCase="'promo_' + currentProduct?.id">
        <sc-animate-arrows class="l"></sc-animate-arrows>
        <sc-animate-arrows class="r"></sc-animate-arrows>
    </ng-container>
</div>

<sc-christmas-lights *ngIf="data?.extra4 === 'christmas-lights'"></sc-christmas-lights>

<div class="bg" *ngIf="data?.image" [style.background-image]="'url('+ env.imagesUrl + data?.image +')'"></div>

<ng-template #promo>
    <article [innerHTML]="data?.content"></article>
    <div class="right">
        <div class="counter" [class.timeout]="timeout" *ngIf="data.enddata">
            <h6 [innerHTML]="timeout ? 'Pozostały ostatnie <span class=\'nobr\'>2 oferty</span>.' : 'Oferta kończy się za: '"></h6>
            <sc-counter-down (ontimeout)="onTimeout($event)" [end]="data.enddata"></sc-counter-down>
        </div>
        <button sc-button class="btn-show" (click)="goToLink()">Sprawdź</button>
    </div>
</ng-template>

<ng-template #redirect>
    <article [innerHTML]="data?.content"></article>
    <button sc-button (click)="goToLink()">Sprawdź</button>
</ng-template>

<ng-template #other>
    <article [innerHTML]="data?.content"></article>
    <button sc-button (click)="setHidden()">Akceptuję pliki cookies</button>
</ng-template>